import React, {memo} from "react";
import Loading from "./Common/components/Loading";

const WebLoader = () => {
    return <Loading size="large"/>
}

export default memo(WebLoader);
